<template>
  <div class="container">
    <div class="news-detail">
      <div class="nd-body">
        <div class="bread-nav">
          <span @click="navgoTo()">全部</span> > 招聘技巧 >
          <span class="txt-gray">{{objData.title}}</span>
        </div>
        <div class="nd-body-content">
          <div class="nd-body-view">
            <div class="nd-body-view-title">{{objData.title}}</div>
            <div class="nd-body-view-from">来源:{{objData.froms}} | {{objData.date}} | 招聘技巧</div>
            <!-- <div class="nd-body-view-content">{{objData.content}}</div>
            <p>但是，这种努力真的能够感动领导吗？</p>-->
            <div class="nd-body-view-content1">
              <img src="../../../static/Recruitment skills.jpg" alt="map" />
            </div>
            <div class="nd-body-view-content">
              <p>【人才招聘法则】</p>
              <h3 class="nd-body-view_h3 nd-body-view3">{{objData.subtitle}}</h3>
              <div>{{objData.contenta}}</div>
              <!-- <div>{{objData.contenta1}}</div>
              <div>{{objData.contenta2}}</div>-->
            </div>
            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">{{objData.subtitleb}}</h3>
              <div>{{objData.contentb1}}</div>
              <!-- <div>{{objData.contentb2}}</div>
              <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>
            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">{{objData.subtitlec}}</h3>
              <div>{{objData.contentc1}}</div>
              <!-- <div>{{objData.contentc2}}</div> -->
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>
            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">{{objData.subtitled}}</h3>
              <div>{{objData.contentd1}}</div>
              <!-- <div>{{objData.contentd2}}</div> -->
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>
            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">{{objData.subtitlee}}</h3>
              <div>{{objData.contente1}}</div>
              <!-- <div>{{objData.contentd2}}</div> -->
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>
            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">{{objData.subtitlef}}</h3>
              <div>{{objData.contentf1}}</div>
              <!-- <div>{{objData.contentd2}}</div> -->
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>
            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">{{objData.subtitleg}}</h3>
              <div>{{objData.contentg1}}</div>
              <!-- <div>{{objData.contentd2}}</div> -->
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>

            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">{{objData.subtitleh}}</h3>
              <div>{{objData.contenth1}}</div>
              <!-- <div>{{objData.contentd2}}</div> -->
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>

            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">{{objData.subtitlei}}</h3>
              <div>{{objData.contenti1}}</div>
              <!-- <div>{{objData.contentd2}}</div> -->
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>

            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">{{objData.subtitlej}}</h3>
              <div>{{objData.contentj1}}</div>
              <!-- <div>{{objData.contentd2}}</div> -->
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>

            <div class="nd-body-view-content">
              <p>【人才招聘原则】</p>
              <h3 class="nd-body-view_h3 nd-body-view3">1. 根据你的公司的价值观进行招聘。</h3>
              <div>
                你绝对有必要公布你的企业的价值观，让候选人能够看到，让价值观融入你的招聘策略之中。
                每一位候选人(当然还有每一位员工)都应该知道你的企业代表什么，成为“家族”的一员意味着什么。不仅仅要说明你要的品质和特征——还要告诉大家你拒绝的价值观。想象一下，你希望人们如何在你的企业中行动，将之作为戒律，然后根据这些戒律进行招聘?
                <p>例如说，在Jobvite我们的核心价值观之一就是客户至上。当我们进行面试的时候，无论是招聘行政助理还是副总裁，我们都会问一些问题，这些问题的答案会告诉我们一名候选人是否会为了客户想方设法，竭尽全力。如果他们不是这样的人，漂亮的学历和技能就毫无意义了。</p>
              </div>
              <!-- <div>{{objData.contentd2}}</div> -->
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>

            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">2. 寻找真正热爱这份工作的人。</h3>
              <div>
                旧金山49人队的前教练Jim Harbaugh现在在密歇根大学担任主教练，他曾经对一群来自硅谷的首席执行官们讲话，告诉他们自己从来不会挑选那些最好、或者最快或者最强壮的球员，而总是去挑选那些真正热爱橄榄球运动的球员。为什么呢?因为橄榄球虽是一项运动，但有些时候，可能会非常痛苦而且困难——只有那些真正热爱玩这个游戏的人，才会历尽艰辛，努力打败别人。同样的，那些真正热爱他们所从事的工作的人，不会介意每天起床来到办公室。他们不会抱怨繁重的工作。他们愿意为了自己的工作加倍努力——无论是制作文档还是组装家具——他们都会竭尽所能。因为他们真正地喜爱自己的工作。
                <p>你会想要这样的人，因为他们的表现将远远超过其他任何类型的求职者。所以在面试的过程中要尽你所能弄清楚，一名求职者是否会积极、愉快地履行他们申请的那份工作要承担的各项职责。</p>
              </div>
              <!-- <div>{{objData.contentd2}}</div> -->
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>

            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">3. 使用评估测试。。</h3>
              <div>
                <p>评估有极大的帮助。它们的科学有效性和复杂程度在过去几十年里已经有了极大的提高，这要感谢我们收集和使用数据的方式的进步。今天，你可以利用这些测试来测试很多事情——例如，完成工作所需要的认知灵活性、对于一份工作的情感适应性、对工作文化的适应程度，以及一个人到底是否会喜欢这份工作和这份工作涉及到的一切。</p>
                <p>我推荐你对每一位求职者都进行管理评估测试——事实上，我建议你对于自己所有的员工都进行同样的测试。随着时间的推移，你可以利用这些结果勾勒出哪种类型的人既能够很好地适应你的公司、又能够完成特定工作——这样当你招聘的时候，你就能够更容易地挑出那些和你最成功的员工非常相似的候选人来。</p>
              </div>
              <!-- <div>{{objData.contentd2}}</div> -->
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>

            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">4. 从离开的那些人那里学习。</h3>
              <div>这样做的目的不仅仅是泛泛地了解某个人不喜欢这份工作或者你的公司的什么地方，而是要利用你了解到的情况，调整招聘的标准，这样你就能够避免招到那些不是很适合的人——或者，更好的情况下，能够真正地调整这份工作，让它变得更有趣，对于更高素质的人才更具吸引力。</div>
              <!-- <div>{{objData.contentd2}}</div> -->
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>

            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">5. 及早检查推荐。</h3>
              <div>
                <p>这一点我以前提到过，但是我认为它非常重要，完全有必要再次提醒一下。有了今天的社交网络，检查一个应聘者的推荐在招聘评估过程中应该是第一步——而不是到了快形成结论的时候再做。进行在线的调查，看看某个人是否适合你所在的组织。请记住，你是在寻找合格的候选人——个人或者专业的推荐可能会成为高度可信赖的信息来源。</p>
                <p>我知道觉得“外面适合填补那些需要很少技能的空缺职位的人多得是”这种想法非常有诱惑力。从某些方面来说也确实如此——没有大学学位的求职者比有大学学位的求职者多多了。</p>
                <p>但是，高素质人才的短缺是永远存在的——就是那些我们都想要和他们共事的人。他们勤奋、有雄心壮志、努力工作、与人为善、谦卑并且每天都会为了你的客户和他们的同事奉献更多。相信我，这样的人永远都不会富裕，所以不要在招聘这样的人的时候放松警惕。</p>
              </div>
              <!-- <div>{{objData.contentd2}}</div> -->
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>

            <div class="nd-body-view-content">
              <p>【人才招聘原则】</p>
              <h3 class="nd-body-view_h3 nd-body-view3">1. 首先要熟知国家法律法规</h3>
              <div>
                招聘时要注意不同地区有不同的规定，首先要了解当地小企业管理局的一些规章制度。你可能还想通过网络与同处在成长期的小企业主们分享经验，包括最得力的会计师、商业背景调查机构等。
              </div>
              <!-- <div>{{objData.contentd2}}</div> -->
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>

            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">2. 在职位描述中突出品牌个性</h3>
              <div>
                <p>如果你的品牌知名度不高，又想吸引最好的人才，你必须为潜在申请人提供有价值的工作机会。其中一种方法就是精心撰写职位描述，向他们展示公司最独特和最令人兴奋的特质。不管是说明你如何颠覆了一个产业，还是分享最近媒体报道的例子，(liuxue86.com)你的职位描述必须令人过目难忘，因为这些申请人正用鼠标滚动数不清的职位信息。</p>
                
              </div>
              <!-- <div>{{objData.contentd2}}</div> -->
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>

            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">3. 与其从零开始组建新团队不如考虑“小组面试”</h3>
              <div>
                <p>如果你正从头组建一个销售团队，你需要经理、高级销售人员和初级员工，你可以考虑把经常合作的人放在一起进行“小组面试”，评估他们一起工作的融合程度和彼此的关系。</p>
                
              </div>
              <!-- <div>{{objData.contentd2}}</div> -->
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>

            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">4. 在面试中坦承职位具有的挑战性</h3>
              <div>
                <p>小微企业跟大企业相比有不同的挑战和机遇，应对潜在申请人据实以告工作中的最大障碍(当然不能泄露企业机密)。如果你招聘的是市场经理，挑战可能是只有很少一点或根本没有广告预算;如果你招聘的是设计师，情况可能是你的网站和企业标识都需要重新设计。那些最好的员工，会迎接挑战并努力寻找解决之道。</p>
                
              </div>
              <!-- <div>{{objData.contentd2}}</div> -->
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>

            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">5. 不断完善培训内容</h3>
              <div>
                <p>保存培训材料能让你的生活轻松惬意，让下一轮培训更为顺畅。这包括签署的税务文件、介绍公司历史的幻灯片、所有新员工需要下载到电脑上的模板和职位描述，把这些全部保存在一个U盘里，或者另建一个新文件夹。新员工上岗几个月之后，问一问哪些信息最有助于他们的成长，并以此为基础完善下一次培训。</p>
                
              </div>
              <!-- <div>{{objData.contentd2}}</div> -->
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>

            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">6. 花心思培植企业文化</h3>
              <div>
                <p>每个员工对企业文化都有至关重要的影响，在小微企业尤其如此。一个人的创造力、消极态度、高效或漠不关心能迅速波及整个组织。即使你时间紧，要签发接收函，完成2015的目标，你还是要认真想想营造怎样的工作环境，哪些企业价值对你来说最重要，并在聘用的人员中重点培养这种品质。</p>

                <p>小企业主的工作千头万绪，不能在人才招聘上出纰漏。记住，在招聘新员工时运用你的理智和情感，永远聘用你真正乐意与之共事的人。
该文章《如何招到合适的人才,人才招聘的策略与技巧》来源于出国留学网，网址：https://www.liuxue86.com/a/2695756.html
</p>
                
              </div>
              <!-- <div>{{objData.contentd2}}</div> -->
              <!-- <div>{{objData.contentb3}}</div>
              <div>{{objData.contentb4}}</div>-->
            </div>

            <div class="nd-body-view-of">
              <div class="nd-body-view-prev">上一篇：{{objData.prev}}</div>
              <div>下一篇：{{objData.next}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShowNewsDetail",
  data() {
    return {
      id: "",
      objData: {
        title: `如何招到合适的人才`,
        date: `2019年9月24日`,
        froms: `播聘`,
        next: `播聘荣登准独角兽百强榜，以技术驱动深耕服务业招聘`,
        prev: `播聘“千人千面”智能推荐策略的产品分析，我的工作我做主 `,
        content: `职场上，有这么一类人，他们每天埋头苦干，加班加点，时不时还在朋友圈晒个周末加班的图片，为的就是让领导看到自己的努力状态，让领导感动，进而给自己升职加薪。`,
        subtitle: `1.建立和充实企业的人才库`,
        contenta: `在企业选聘新员工时，自己找上门或看到报纸、网络的招聘广告后打电话应聘的这二类候选人中，一般情况下是缺乏优秀人才的。最佳的人才往往都已拥有一份工作，甚至还没有必要去寻求新的职位。企业惟有花一些时间和高等院校的就业指导中心、专业人才服务机构建立良好的关系，并鼓励内部员工积极参与行业内的专业组织与活动，惟此，才有可能成功地寻找到优秀的人才。因为，这二个方式大大改善了企业的人才库，使企业甄选人才的范围得以扩大。此外，经常浏览人才网站，将一些合适的人才简历收入企业的人才库中;注意在一些专业的网站与刊物上发布招聘广告也会有所帮助。这些做法的关键是在企业需要一个优秀的人才库之前就先建立好它。
`,
        // contenta1: `4G改变生活，5G改变社会。播聘平台顺应5G的时代趋势而生。作为目前唯一的大数据视频招聘生活社交服务平台，播聘全心致力于“让天下没有难招的工，没有失业的人”的伟大事业。目前国内业务主要集中在全国一线城市及各个省会城市，未来还会扩展至全球数十个重要的地区和国家。`,
        // contenta2: `与传统招聘平台不同的是，播聘结合大数据、云计算、用户画像等技术开创的视频简历与视频面试的生活新方式，是人工智能时代对招工方式的一次颠覆与创新。`,

        subtitleb: `2.做出正确的雇用决定`,
        contentb1: `企业聘用新员工时都希望其“在特定的行业、特定的企业环境中能够正确地从事正确的工作，而且最好是来自一个企业文化非常相似的组织。”不少HR经理笃信“过去的行为是未来行为的最好预测”的观点，并认为这可使企业成功地招聘到需要的、合适的人才，成为人才招聘中的赢家。同时，也有一些企业认为雇用的新员工应该是进入企业即能发挥作用的人才，而不是花费时间与财力去培训一名潜在的成功候选人。这些是企业做出雇用决定的基础。
`,
        // contentb2: `另一方面，企业不仅可以在播聘平台上发布岗位要求和招工信息，还可以上传视频到平台以呈现公司的企业文化、工作环境、工作氛围等，有助于求职者直观、全面地了解企业，吸引志同道合的伙伴，同时增加企业关注度和影响力。`,
        // contentb3: `对求职者来说，播聘平台倡导“秀出真我”，求职者通过视频简历可以直观地展现工作技能、兴趣爱好、个人性格，有效突破文字简历的平面性和局限性，同时提高个人简历的吸引力和价值。`,
        // contentb4: `播聘平台通过系统数据分析求职者的求职意向，精准推送与之匹配的岗位，企业在看过求职者的视频简历后，即可在线视频面试，不仅大幅度降低求职者的时间成本，而且提升了求职成功率。`,

        subtitlec: `3.从内部挖掘人才`,
        contentc1: `为内部员工提供晋升的机会可对现有员工的士气起到非常积极的推动作用，并增强他们的自信心，让他们充分认识到自己的才能，这本身就是认可员工的最好方式。在出现岗位空缺的时候，首先从内部挖掘人才，给有实力的候选人以面试的机会，员工可据此了解组织的需求与目标，实际上这也是HR更好地了解企业内人才的绝佳机会。有时，HR会在企业的需求与员工需求之间找到一个非常好的平衡点，一旦找到，将对企业内部的员工产生非常良好的影响。
`,

        subtitled: `4.成为知名的雇主`,
        contentd1: `在人才竞争日益激烈的时代，企业的目标不仅仅要成为最佳雇主，而且要让求职者都清楚地知道这一点，这就好比做人要有好的口碑。重视企业的雇员保持、激励、责任、报酬、认可、制度灵活性、在员工工作与生活中的平衡及员工的参与程度，是企业成为最佳雇主的关键因素。而如果企业现有员工逢人便夸赞自己所处的企业是一个非常棒的工作地方，企业外的潜在雇员就会因此认可你的企业的确是优秀的雇主而选择你，这大大增强了对潜在雇员的吸引力。
`,
        // contentd2: `雪莱在《西风颂》中曾说过：如果冬天来了，春天还会远吗？在“经济寒冬”的浪潮下，播聘将搭建起企业和求职者沟通的桥梁，让企业和求职者各取所需、共同发展，为中国的人力资源行业贡献一份力，为中国经济创造新奇迹增添一份彩！`
        subtitlee: `5.让员工参与雇用过程`,
        contente1: `企业有三个机会让员工参与雇用过程：一是让他们推荐优秀的候选人到企业中，二是协助HR审核潜在候选人的简历与资格，三是协助HR面试潜在的候选人，评估他们的潜力是否“适合”组织的需求。如果企业没有充分运用现有员工评估潜在雇员，那是对企业最重要资产的一种浪费。此外，让员工参与新员工的甄选过程同时也有助于新旧员工的承继性。

`,
        subtitlef: `6.提供比行业平均水平稍高的薪酬`,
        contentf1: `支付多高层次的薪水，就雇用到多高层次的人才。这是一个定律。然而，没有几个企业愿意提供业内最优厚的薪水，但不可否认的是，薪酬对人才的吸引力是始终存在的。薪水高、福利待遇好的企业能够吸引并留住雇员，这是毋庸置疑的。因此，调查所在地就业市场并关注企业的薪酬在行业内的吸引力就变得不可或缺。
`,
        contentf2: `一般来说，企业支付稍高于行业平均水平的薪酬即可吸引与保持优秀的人才。这看似很简单，却很少有企业做到了这一点。绝大多数雇主每天都会与HR讨论怎样才能雇用到可以支付较低薪酬的优秀人才，这是一个非常危险的想法。没错，有时企业也有机会以较低的薪酬吸引到一些非常优秀的人才，但有可能是因为他们的配偶或家庭问题，或看重企业福利而入职。即使他们工作非常积极，绩效不错，仍会为他们的薪酬感到不公平而心有怨言，一旦有更好的机会他们就会选择离职。`,
        contentf3: `此外，让员工感觉到薪酬的公正性也至关重要。如果企业能够提供的薪酬比候选人要求的少，而企业已经决定雇用他的话，就要说服他接受这份工作，指出这份工作将如何能使他发挥自己的创造能力、做自己感兴趣的事情以及实现自己的职业目标。`,
        subtitleg: `7.将福利作为重要的竞争优势`,
        contentg1: `将企业的福利保持在行业的标准之上并适时为员工提供力所能及的新的福利内容非常有助于留住员工的心。同时，也要让员工知道所得到福利的价值与组织在这方面投入的费用，使员工明白组织是在不断地努力满足他们的需求。要注意平衡员工在工作与生活上的责任与兴趣，并为此尽可能提供机会与制度上的灵活性。目前，员工已经日益趋向于自助餐式的福利计划，这样他们才能更好地在工作、生活与家庭之间取得平衡。此外，根据员工绩效实施奖金分配也是不可或缺的。这里要注意的是不要照搬其他公司的福利形式，最好通过与员工的谈话确定他们的兴趣所在。因为，适用于某一人群的形式并不必然适用于另一人群。

`,
        subtitleh: `8.雇用你所能找到的最突出的人`,
        contenth1: `一般来说，员工并不喜欢过于频繁地变换工作，因此，没有必要花费时间去考虑谁要离开，但一定要努力搞清楚他们会留下什么，这就足够了!如果企业的需求是要寻找一个能与同事融洽相处的人才，就必须雇用到一个在与同事相处方面不会有问题的人，而不能寄希望于在他入职后再去培训他所缺乏的能力。同时，要善于发现员工的长处，雇用时不能只盯着候选人在习惯与才能上的弱点，而要看其主要的优势与职位需求的吻合度，要知道，找到完美的雇员实际上是不可能的。在如今的人才市场上，能找到80%适合岗位的人就已经很幸运了。
`,
        subtitlei: `9.合理运用企业的网站`,
        contenti1: `企业网站一般描绘了企业的愿景、使命、目标、价值观与产品，不可忽视的是，企业的网站同时也极易吸引那些浏览过网站、对空缺岗位感兴趣且与企业文化适合的候选人投送简历。因此，有网站的企业不妨建立一个招聘页面，把企业的空缺职位、职位需求、任职资格等做出清晰的描述，这会吸引很多合适的候选人投递简历，一般情况下，这些候选人都对企业的空缺职位非常感兴趣。`,
        subtitlej: `10.推荐人核实`,
        contentj1: `推荐人核实是背景调查的一部分，常会被人力资源管理人员所忽视。背景调查的目的在于切实避免企业寻找与选择的候选人给企业带来一些不必要的麻烦。推荐人核实是通过与认识候选人的人，最好是他以前的上司或同事进行电话沟通，充分了解候选人的情况，以确认候选人的资质、才能是否胜任空缺职位，并确认候选人在简历上及面试过程中所描述的工作业绩是否属实。运用这一方法可以确保准备雇用的候选人能在入职后有效地履行职责。`,
        contentj2: `此外，还要查清雇用的员工没有过往的不良记录，以避免危及企业内的员工。事实上，如果因未做好背景调查而导致新聘用的员工资质太差或产生其他不利于企业的影响，HR要负相应的责任。`
      }
    };
  },
  created(option) {
    this.init();
  },
  methods: {
    init() {
      let _this = this;
      _this.id = _this.$route.query.id || ``;
    },
    navgoTo() {
      this.$nav({ path: `/show-news` }, this);
    }
  }
};
</script>

<style scoped="scoped">
@import url("./recruitment-skills_to.css");
</style>



// WEBPACK FOOTER //
// src/pages/recruitment-skills_to/recruitment-skills_to.vue